import React, { ReactElement } from 'react';
import { Modal } from 'react-bootstrap';
import './VoiceguestRemoveModal.scss';
import { IResponseUserPairData } from '../../../../services/api/models/response/responseVoicePlus';

interface VoiceGuestRemoveModalProps {
  audientGuest?: IResponseUserPairData;
  toggleRemoveModal: boolean;
  callbackHandleAcceptRemoveAudient?: () => void;
  callBackToggleModal?: () => void;
}

export const VoiceGuestRemoveModal = (
  props: VoiceGuestRemoveModalProps,
): ReactElement => {
  const {
    audientGuest,
    toggleRemoveModal,
    callbackHandleAcceptRemoveAudient,
    callBackToggleModal,
  } = props;
  return (
    <Modal
      show={toggleRemoveModal}
      centered
      backdrop="static"
      size="sm"
      className="voiceguest-remove-modal"
    >
      <div className="voiceguest-remove-modal-wrapper">
        <div className="voiceguest-remove-modal-title">ペア終了</div>
        <div className="voiceguest-remove-modal-body">
          <div className="voiceguest-remove-modal-body-question">
            {audientGuest?.loginId} さんとのPair配信を終了しますか？
          </div>
          <img
            src={audientGuest?.picture?.uri}
            alt={audientGuest?.loginId}
            className="voiceguest-remove-modal-body-img"
          />
          <div className="voiceguest-remove-modal-body-btns">
            <button
              className="voiceguest-remove-modal-body-btn-cancel"
              onClick={callBackToggleModal}
            >
              キャンセル
            </button>
            <button
              className="voiceguest-remove-modal-body-btn-accept"
              onClick={callbackHandleAcceptRemoveAudient}
            >
              終了する
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};
